// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import BatchActionsController from "./batch_actions_controller";
application.register("batch-actions", BatchActionsController);

import BatchChartGeneratorController from "./batch_chart_generator_controller";
application.register("batch-chart-generator", BatchChartGeneratorController);

import BatchSelectionController from "./batch_selection_controller";
application.register("batch-selection", BatchSelectionController);

import CollapseController from "./collapse_controller";
application.register("collapse", CollapseController);

import DashboardChartController from "./dashboard_chart_controller";
application.register("dashboard-chart", DashboardChartController);

import HelpSearchController from "./help_search_controller";
application.register("help-search", HelpSearchController);

import MarkResultChartController from "./mark_result_chart_controller";
application.register("mark-result-chart", MarkResultChartController);

import MarkResultFormController from "./mark_result_form_controller";
application.register("mark-result-form", MarkResultFormController);

import ManualEntryRowsController from "./manual_entry_rows_controller";
application.register("manual-entry-rows", ManualEntryRowsController);

import MarkTaskPriceFormController from "./mark_task_price_form_controller";
application.register("mark-task-price-form", MarkTaskPriceFormController);

import ProjectUnitFormController from "./project_unit_form_controller";
application.register("project-unit-form", ProjectUnitFormController);

import PricingModeFormController from "./pricing_mode_form_controller";
application.register("pricing-mode-form", PricingModeFormController);

import SettlementPeriodFormController from "./settlement_period_form_controller";
application.register("settlement-period-form", SettlementPeriodFormController);

import SidebarController from "./sidebar_controller";
application.register("sidebar", SidebarController);

import ToastController from "./toast_controller";
application.register("toast", ToastController);

import ThemeController from "./theme_controller";
application.register("theme", ThemeController);

import TierPriceFormController from "./tier_price_form_controller";
application.register("tier-price-form", TierPriceFormController);
